<template>
  <transition name="fade">
    <div v-if="isVisible" class="absolute inset-x-0 top-0 z-30 text-center">
      <div
        v-for="item in dataNotification"
        :key="item.id"
        :class="[bgColor, fontColor]"
        class="h-10 text-white flex justify-center items-center py-2 opacity-90"
      >
        {{ item.message }}
      </div>
    </div>
  </transition>
</template>

<script setup lang="ts">
import { ref, onMounted, onBeforeUnmount } from "vue";
import { useI18n } from "vue-i18n";
import axios from "axios";

defineOptions({ name: "SplashScreen" });

const { t } = useI18n();

const isVisible = ref(false);
const bgColor = ref("bg-danger");
const fontColor = ref("text-white");
const dataNotification = ref<any[]>([]);
const responseTimer = ref<ReturnType<typeof setTimeout> | null>(null);

const getAlarmNotification = async () => {
  if (import.meta.env.VITE_APP_HEALTHCHECK_URL) {
    try {
      const response = await axios.get(import.meta.env.VITE_APP_HEALTHCHECK_URL);
      if (response.data === null) {
        isVisible.value = false;
      } else {
        isVisible.value = true;
        dataNotification.value = [response.data];

        if (!response.data.message || response.data.message === "") {
          bgColor.value = "bg-danger";
          response.data.message = t("Errors.SplashNotificationError");
        }

        if (response.data.severity === "Yellow") {
          bgColor.value = "bg-warning";
          fontColor.value = "text-black";
          response.data.message = t("Errors.SplashNotificationMessage");
        }
      }
    } catch {
      /* empty */
    } finally {
      responseTimer.value = setTimeout(getAlarmNotification, 30000);
    }
  }
};

onMounted(() => {
  getAlarmNotification();
});

onBeforeUnmount(() => {
  if (responseTimer.value) clearTimeout(responseTimer.value);
});
</script>
